export default __webpack_public_path__ + "static/media/Banner.7a41793b.png";